import React, { FC } from "react";
import styles from "./appointment-request-tag.module.scss";
import { Resource_AppointmentRequestStatus } from "../../src/generated/graphql";
import { Maybe } from "graphql/jsutils/Maybe";
import {
  AppointmentRequestStatusBadgeColors,
  AppointmentRequestStatusTitles,
  AppointmentRequestStatusTitlesShort,
} from "../../helpers/enum-maps";
import { useIntl } from "react-intl";
import { Tooltip } from "antd";

interface AppointmentRequestStatusTagProps {
  status: Maybe<Resource_AppointmentRequestStatus> | undefined;
  unverified: Maybe<boolean> | undefined;
}

export const AppointmentRequestStatusTag: FC<
  AppointmentRequestStatusTagProps
> = ({ status, unverified }) => {
  const { formatMessage } = useIntl();

  const colorSet = AppointmentRequestStatusBadgeColors.get(
    status || Resource_AppointmentRequestStatus.AppointmentRequestStatusNone
  );

  return (
    <Tooltip
      title={
        unverified
          ? formatMessage({
              id: "appointment-request.not-verified.description",
            })
          : formatMessage({
              id: AppointmentRequestStatusTitles.get(
                status ||
                  Resource_AppointmentRequestStatus.AppointmentRequestStatusNone
              ),
            })
      }
    >
      <span
        className={styles.appointmentRequestTag}
        style={{
          backgroundColor: unverified ? "darkred" : colorSet?.[0],
          color: unverified ? "white" : colorSet?.[1],
          border: `1px solid ${colorSet?.[1]}`,
          whiteSpace: 'nowrap',
        }}
      >
        {unverified
          ? formatMessage({ id: "appointment-request.not-verified" })
          : formatMessage({
              id: AppointmentRequestStatusTitlesShort.get(
                status ||
                  Resource_AppointmentRequestStatus.AppointmentRequestStatusNone
              ),
            })}
      </span>
    </Tooltip>
  );
};
